/**
 * @packageDocumentation
 * @module f1/is
 */

import to_type from '../to/to_type';

export interface IsError {
  /**
   * Is a boolean
   *
   * @public
   * @function f1.is.error
   * @example
   *
   * ```ts
   * f1.is.error(new Error('uh oh')) => true
   * ```
   */
  (value: unknown): value is Error;
}

/**
 * @see IsError
 */
export default (value: unknown): value is Error => {
  return to_type(value) === 'Error';
};
